import {Subscription} from 'rxjs';

import IPlayer                    from '../../../Player/Interfaces/IPlayer';
import createPlaybackStatusStream from '../../../Shared/Streams/createPlaybackStatusStream';
import createCueChangeStream      from '../../../Solutions/Shared/Streams/createCueChangeStream';

import createCaptionsOptionTapStream from './Streams/createCaptionOptionTapStream';
import createPlaybackReadyStream     from './Streams/createPlaybackReadyStream';
import subscribeToCaptionsOptionTap  from './Subscribers/subscribeToCaptionsOptionTap';
import subscribeToCueChange          from './Subscribers/subscribeToCueChange';
import subscribeToFrameStoreUpdate   from './Subscribers/subscribeToFrameStoreUpdate';
import subscribeToPlaybackReady      from './Subscribers/subscribeToPlaybackReady';

const connectConfigSubscriptions = (player: IPlayer): Subscription[] => {
    const {solution, state} = player;
    const {captions, frame, playback} = state.stores;
    const {uiEvents$} = player.ui;

    return [
        subscribeToCaptionsOptionTap(createCaptionsOptionTapStream(uiEvents$), captions),
        subscribeToFrameStoreUpdate(frame.update$, captions),
        subscribeToPlaybackReady(
            createPlaybackReadyStream(createPlaybackStatusStream(playback.update$)),
            solution,
            captions
        ),
        subscribeToCueChange(createCueChangeStream(solution.mediaEvents$), captions)
    ];
};

export default connectConfigSubscriptions;